export default __webpack_public_path__ + "static/media/Example-1723036121651.5f38fc86.PNG";